import { Operation, OperationWithAlarm } from '../../types/sharedTypeImpl.ts';


type Props = {
    operation: Operation | OperationWithAlarm;
};

export function OperationDetails({
    operation,
}: Props) {
    const toolChangeAlarm = (operation as OperationWithAlarm || { toolChangeAlarm: undefined }).toolChangeAlarm;
    const toolChangeIcon = toolChangeAlarm === 'active' ? ' 🔴' : toolChangeAlarm === 'fixed' ? ' ⚪' : '';
    const mainText = operation.details.join(' > ') + toolChangeIcon;

    const collateralList = operation.collateralDamage?.map((it) => `${it.toolVariant} ${it.toolNumber}`);
    const collateralText = collateralList?.length ? `(Collateral: ${collateralList.join('; ')})` : null;

    return (
        <>
            <span>{mainText}</span>
            {collateralText && (
                <>
                    <br />
                    <span>{collateralText}</span>
                </>
            )}
        </>
    );
}
